__turbopack_context__.v({
  "quantityModifier": "CartItemQuantityWidget-module-scss-module__oiX0ZW__quantityModifier",
});
